import Button from './ui/NavbarButton';
import React, { useState, useEffect } from 'react';

export default function Header() {

  // FUNZIONE PER CONTROLLARE LO SCROLL ACTIVE
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const sections = document.querySelectorAll('.section');  // Seleziona tutte le sezioni della pagina

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);  // Imposta la sezione attiva
          }
        });
      },
      // --- MODIFICA CHIAVE ---
      // Ho abbassato la soglia da 0.5 a 0.3.
      // Ora la sezione si attiverà quando almeno il 30% è visibile,
      // risolvendo il problema per le sezioni molto alte come "Resume".
      { threshold: 0.3 }
    );

    sections.forEach((section) => {
      observer.observe(section);  // Inizia a monitorare ogni sezione
    });

    // Cleanup dell'observer quando il componente viene smontato
    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);


  return (
    <header>
      <nav className='navbar'>
          <a href="#home" className={activeSection === 'home' ? 'active' : ''}>
            <Button text='Home' icon='bx bx-home-alt'></Button>
          </a>
          <a href="#about" className={activeSection === 'about' ? 'active' : ''}>
            <Button text='Profilo' icon='bx bxs-user'></Button>
          </a>
          <a href="#resume" className={activeSection === 'resume' ? 'active' : ''}>
            <Button text='Percorso' icon='bx bx-file-blank'></Button>
          </a>
          <a href="#portfolio" className={activeSection === 'portfolio' ? 'active' : ''}>
            <Button text='Portfolio' icon='bx bx-briefcase'></Button>
          </a>
      </nav>
    </header>
  )
}
